var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.431 48.979h28.543c5.172 0 9.379-4.207 9.379-9.379s-4.208-9.379-9.379-9.379H56.431a1.5 1.5 0 0 0-1.5 1.5v15.758a1.5 1.5 0 0 0 1.5 1.5Zm1.5-15.758h27.043c3.518 0 6.379 2.861 6.379 6.379s-2.862 6.379-6.379 6.379H57.931V33.221Zm27.043 18.671H56.431a1.5 1.5 0 0 0-1.5 1.5v15.759a1.5 1.5 0 0 0 1.5 1.5h28.543c5.172 0 9.379-4.208 9.379-9.38s-4.208-9.379-9.379-9.379Zm0 15.759H57.931V54.892h27.043c3.518 0 6.379 2.862 6.379 6.38s-2.862 6.379-6.379 6.379ZM50.186 48.979a1.5 1.5 0 0 0 1.488-1.688c-1.407-11.15-11.261-19.559-22.92-19.559-12.741 0-23.106 9.989-23.106 22.268s10.366 22.268 23.106 22.268c11.347 0 20.924-7.832 22.772-18.623a1.498 1.498 0 0 0-1.478-1.753H29.336v-2.913h20.85Zm-22.35 5.913h20.347c-2.282 8.43-10.178 14.376-19.429 14.376-11.087 0-20.106-8.644-20.106-19.268s9.02-19.268 20.106-19.268c9.551 0 17.706 6.443 19.652 15.246h-20.57a1.5 1.5 0 0 0-1.5 1.5v5.913a1.5 1.5 0 0 0 1.5 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCb);
export default __webpack_public_path__ + "static/media/cb.e1d106b2f409031c9bb7a5a7af8279ec.svg";
export { ForwardRef as ReactComponent };